import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { AuthService } from '../../services/AuthService';

const REDIRECT_SECONDS = 3;

// Shown when there is no valid login session. Sends the user to the Next.js
// login page on its own after a short countdown (the button just skips the wait).
export const SessionExpiredModal: React.FC<{ neverSignedIn?: boolean }> = ({ neverSignedIn = false }) => {
  const [seconds, setSeconds] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (seconds <= 0) {
      window.location.href = AuthService.getLoginUrl();
      return;
    }
    const timer = setTimeout(() => setSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds]);

  return (
    <Modal show centered backdrop="static" keyboard={false}>
      <Modal.Body className="p-4 text-center">
        <div style={{ fontSize: '2.5rem', lineHeight: 1 }}>🔒</div>
        <h5 className="fw-bold mt-3 mb-2">{neverSignedIn ? 'Please sign in' : 'Your session has expired'}</h5>
        <p className="text-muted mb-4">
          {neverSignedIn ? 'Sign in to continue.' : 'Please sign in again to continue.'}
          <br />
          Redirecting to the login page{seconds > 0 ? ` in ${seconds}s` : ''}…
        </p>
        <Button
          variant="primary"
          className="rounded-pill px-4 d-inline-flex align-items-center gap-2"
          onClick={() => { window.location.href = AuthService.getLoginUrl(); }}
        >
          {seconds <= 0 && <Spinner animation="border" size="sm" />}
          Log in now
        </Button>
      </Modal.Body>
    </Modal>
  );
};
